import React, { ReactElement } from 'react';

import Select, { GroupBase, Props } from 'react-select';

import { COLORS } from 'styles/constants';

// import { CustomSelectSearch } from './styles';

function CustomSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>): ReactElement {
  return (
    <Select
      {...props}
      theme={(theme) => ({
        ...theme,
        borderRadius: 5,
        colors: {
          ...theme.colors,
          primary: COLORS.primary,
          primary25: COLORS.secondary,
          primary50: COLORS.background,
          primary75: COLORS.errorRed,
        },
      })}
    />
  );
}

export default CustomSelect;
